import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

type GridTitle = { text: string; size: number };
interface IGridTitles {
  titles: GridTitle[];
  ml?: number;
}
export const GridTitles = (props: IGridTitles) => {
  return (
    <>
      <Grid
        container
        sx={{
          mb: 2,
          ml: props.ml,
        }}
      >
        {props.titles.map((title) => (
          <Grid key={title.text} size={title.size}>
            <Typography>{title?.text}</Typography>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
